module.exports = __webpack_public_path__ + "static/media/about-pets.198b7743.png";